// extracted by mini-css-extract-plugin
export default {"button":"StyledButton_button__29GcU","borderless":"StyledButton_borderless__GToJE","danger":"StyledButton_danger__Y5rQl"};